import { useEffect, useState } from 'react';
import packageJson from '@package';

global.appVersion = packageJson.version;

const CacheBuster = props => {
	const { children } = props,
		[loading, setLoading] = useState(true),
		[isLatestVersion, setIsLatestVersion] = useState(false);

	useEffect(() => {
		fetch('/meta.json')
			.then(response => response.json())
			.then(meta => {
				const latestVersion = meta.version,
					currentVersion = global.appVersion,
					shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion),
					strStatus = shouldForceRefresh ? `v${latestVersion} available` : 'latest';

				console.log(`v${currentVersion} (${strStatus})`);

				setLoading(false);
				setIsLatestVersion(!shouldForceRefresh);
			});
	}, []);

	useEffect(() => {
		if (!loading && !isLatestVersion) {
			console.log('Clearing cache and hard reloading...');

			if ('caches' in window) {
				cache.keys().then(keys => {
					keys.forEach(req => cache.delete(req));
				});
			}

			window.location.reload(true); // delete browser cache and hard reload
		}
	}, [loading, isLatestVersion]);

	return loading ? null : children;
};

// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
	const versionsA = versionA.split(/\./g),
		versionsB = versionB.split(/\./g);

	while (versionsA.length || versionsB.length) {
		const a = Number(versionsA.shift()),
			b = Number(versionsB.shift());

		if (a === b) continue;

		return a > b || isNaN(b);
	}

	return false;
};

export default CacheBuster;
